import { Reveal, SectionHeader } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Personalized Strength & Power Programming",
    desc: "Custom weightroom work built for rotational power, posterior chain strength, and long-term shoulder health.",
  },
  {
    n: "02",
    title: "Sprint & Speed Work",
    desc: "60-yard dash mechanics, first-step acceleration, and the lateral quickness the game actually demands.",
  },
  {
    n: "03",
    title: "Ongoing Program Adjustments",
    desc: "Your program adapts weekly to your game load, schedule, and how your body is responding. Nothing static.",
  },
  {
    n: "04",
    title: "Performance Tracking",
    desc: "Measurable progress — strength numbers, speed times, and jump metrics tracked so you always know where you stand.",
  },
  {
    n: "05",
    title: "Nutrition Guidance",
    desc: "Straightforward fueling for building lean mass, recovering between games, and showing up ready every day.",
  },
  {
    n: "06",
    title: "Direct Access To Me",
    desc: "A direct line to your coach. Questions, video feedback, adjustments — you get me, not an assistant or a bot.",
  },
];

export default function WhatYouGet() {
  return (
    <section className="py-20 sm:py-28 lg:py-36 bg-[#141416]" data-testid="what-you-get-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader index="02" label="What You Get" title="The Full Coaching Stack" />
        <div className="border-t border-zinc-800">
          {CHAPTERS.map((ch, i) => (
            <Reveal key={ch.n} delay={i * 0.06}>
              <div
                className="group grid grid-cols-[auto_1fr] sm:grid-cols-[120px_1fr_1.2fr] gap-x-6 gap-y-2 items-baseline py-7 sm:py-9 border-b border-zinc-800 hover:bg-[#0B0B0C]/60 transition-colors duration-300 px-2 sm:px-4"
                data-testid={`what-you-get-item-${i}`}
              >
                <span className="font-display text-4xl sm:text-5xl text-zinc-700 group-hover:text-[#CCFF00] transition-colors duration-300">
                  {ch.n}
                </span>
                <h3 className="font-display uppercase text-2xl sm:text-3xl tracking-wide text-white leading-none">
                  {ch.title}
                </h3>
                <p className="col-span-2 sm:col-span-1 text-sm text-zinc-400 leading-relaxed sm:pl-6">
                  {ch.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
